// Deprecated. This is only for back compatibility by tests!
console.warn('Deprecated! Please use require("@iobroker/db-objects-redis").Client library in tests!');

import { Client } from '@iobroker/db-objects-redis';
export default Client;
